/**
 * Remplace l'URL de la barre d'adresse sans prévenir le routeur.
 *
 * @tanstack/history remplace `window.history.replaceState` sur l'instance pour notifier le routeur : un appel
 * direct lui ferait relire l'URL nettoyée (search vide, ou route introuvable) et la page perdrait son token
 * avant même l'appel API. La méthode du prototype reste l'originale : le routeur garde son état, la page reste
 * montée, seule la barre d'adresse change.
 */
export const replaceUrlSilently = (url: string): void => {
  History.prototype.replaceState.call(window.history, window.history.state, '', url);
};
